define('services/componentViewService',[], function () {
    'use strict';

    /**
     * Stores views so they can be retrieved later.
     * 
     * This is intended to allow component developers to write/debug views in their component
     * and display them in an area that is owned by the core Engage application.
     * 
     * Currently, this is used by componentLoader.js.  It relies on a component adding a sharedViews 
     * property to their componentDefinition.  See example usage in AgentDashboardContainerView.
     * 
     * This is an example object from the WFM component:
     * sharedViews.agentDashboardSchedule = {
     *     viewModel: AgentSchedule,
     *     template: 'components/wfm/templates/agentSchedule/AgentSchedule',
     *     isAuthorized: function () {
     *         return authService.hasAuthorization('perm:wfm:agentSchedule:view');
     *     } 
     * };
     */
    
    var storedViews = {};
    
    var componentViewService = {
        setSharedViewsForComponent: function (componentName, views) {
            storedViews[componentName] = views;
        },
        getSharedView: function (componentName, viewName) {
            if (storedViews[componentName]) {
                return storedViews[componentName][viewName];
            } else {
                return null;
            }
        }
    };

    return componentViewService;
});

